<h3 style="text-align:center;font-size:1.77rem;font-weight:500">
    Cartas Amonestación
</h3>

<!-- Spinner de carga -->
<div *ngIf="loadingData" class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- Tabla de datos -->
<table mat-table id="tabla" [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="!loadingData">
    <ng-container matColumnDef="rut">
        <th mat-header-cell *matHeaderCellDef> RUT </th>
        <td mat-cell *matCellDef="let element"> {{ element.carta_trabajador.rut | formatoRut }} </td>
    </ng-container>

    <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> FECHA </th>
        <td mat-cell *matCellDef="let element">{{ element.FechaEmision | date:'dd/MM/yyyy'}}</td>
    </ng-container>

    <ng-container matColumnDef="grado">
        <th mat-header-cell *matHeaderCellDef> GRADO </th>
        <td mat-cell *matCellDef="let element"> {{ element.Grado | uppercase }} </td>
    </ng-container>

    <ng-container matColumnDef="motivo" style="width: 30%;">
        <th mat-header-cell *matHeaderCellDef> MOTIVO </th>
        <td mat-cell *matCellDef="let element"> {{ element.Motivo | uppercase }} </td>
    </ng-container>

    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
        <td mat-cell *matCellDef="let element">

            <p-button class="mr-2" (click)="Descargar(element.id)" icon="pi pi-search" styleClass="p-button-rounded p-button-primary p-button-text" ></p-button>

            <p-button
            *ngIf="!isAuditor"
            class="mr-2"
            icon="{{ loading ? 'pi pi-spin pi-spinner' : 'pi pi-trash' }}"
            styleClass="p-button-rounded p-button-danger p-button-text"
            [disabled]="element.pendienteSolicitud || loading"
            [pTooltip]="element.pendienteSolicitud ? 'Esperando aprobación' : ''"
            tooltipPosition="bottom"
            (onClick)="Borrar(element.id)"
          >
          </p-button>

        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
